export default __webpack_public_path__ + "static/assets/ee0511f11ee6013b0381a464e066facd.svg";